import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import {
    Navbar,
    Nav,
    NavDropdown,
    Image
} from "react-bootstrap";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { logoutUser } from "actions/authActions";
import { fetchApiInfo } from "actions/apiInfoActions";
import HeaderMenu from "components/layout/header-menu";

import logo from "img/logo.jpg";
import UserTypes from "components/auth/user-types";

class Header extends Component {
    constructor(props) {
        super(props);

        props.fetchApiInfo();
    }

    onLogoutClick(e) {
        e.preventDefault();
        this.props.logoutUser();
    }

    render() {
        const { isAuthenticated, user } = this.props.auth;
        const { apiInfo } = this.props;

        const apiInfoItem = (
            <Nav.Item>
                <Nav.Link eventKey="link-1">
                    <FontAwesomeIcon
                        icon="info-circle"
                        data-tip
                        data-for="tooltip-api-version"
                        data-place="left"
                    />
                    {apiInfo ?
                        <ReactTooltip id="tooltip-api-version" effect='solid'>
                            Build Version: <b>{apiInfo.frontend.version}</b>
                            <br/>
                            Server Version: <b>{apiInfo.backend.version}</b>
                        </ReactTooltip>
                    : null}
                </Nav.Link>
            </Nav.Item>
        );

        const userName = user.family_name ? `${user.family_name}, ${user.given_name}` : user.unique_name;
        const authLinks = (
            <Nav className="ml-auto">
                  <NavDropdown
                    title={userName}
                    alignRight
                    id="collasible-nav-dropdown"
                  >
                    <NavDropdown.Item onClick={this.onLogoutClick.bind(this)}>
                      Logout
                    </NavDropdown.Item>
                  </NavDropdown>

                {apiInfoItem}
            </Nav>
        );

        const guestLinks = (
            <Nav className="ml-auto">
                <Nav.Link href="/">Login</Nav.Link>
                {apiInfoItem}
            </Nav>
        );

        const isMerchandiser = user && user.role &&
         user.role.includes(UserTypes.merchandiser) &&
         !user.role.includes(UserTypes.supervisor);

        const isCustomer = user && user.role &&
            user.role.includes(UserTypes.customer);

        let dashboardUrl = "/dashboard";
        if (isMerchandiser) {
            // dashboardUrl = "/schedules/active";
            dashboardUrl = "/dashboard";
        } else if (isCustomer) {
            dashboardUrl = "/summary";
        }

        return (
            <Navbar
                collapseOnSelect
                expand="lg"
                bg="light"
                className="mb-4 px-5"
            >
                <Link
                    to={dashboardUrl}
                    className="navbar-brand"
                >
                    <Image
                        src={logo}
                        rounded
                        style={{
                            width: 100,
                            height: 40
                        }}
                    />
                </Link>

                <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                {!isCustomer ? <HeaderMenu /> : null}

                <Navbar.Collapse id="responsive-navbar-nav">
                    {isAuthenticated ? authLinks : guestLinks}
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

Header.propTypes = {
    logoutUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    apiInfo: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    apiInfo: state.apiInfo
});

const mapStateToDispatch = dispatch => ({
    fetchApiInfo: bindActionCreators(fetchApiInfo, dispatch),
    logoutUser: bindActionCreators(logoutUser, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(Header);
